import { observer } from "mobx-react-lite";
import { FC } from "react";
import { TestableProps } from "@/domains/testing/types";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import { Button } from "react-aria-components";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight, MDSIcon, MDSIconKind } from "@/mds";

export interface AuthCardAppleButtonBaseProps extends TestableProps {
  onClick: () => void;
  label: string;
}

export const AuthCardAppleButtonBase: FC<AuthCardAppleButtonBaseProps> = observer(
  ({ onClick, label, testId }) => {
    const theme = useTheme();

    return (
      <StyledAuthButton onClick={onClick} data-test-id={testId}>
        <MDSIcon
          kind={MDSIconKind.BrandApple}
          size={18}
          boxSize={20}
          overrideColor={theme.colors.text.contrast}
        />
        <MDSText
          variant={MDSTextVariant.TextM}
          weight={MDSTextWeight.Regular}
          color={MDSTextColor.Contrast}
        >
          {label}
        </MDSText>
      </StyledAuthButton>
    );
  }
);

const StyledAuthButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes["text-m"]};
  border-radius: ${({ theme }) => theme.borderRadius.max};
  display: flex;
  box-sizing: border-box;
  width: min(320px, 100%);
  padding-block: ${({ theme }) => theme.spacing[4]};
  padding-inline: ${({ theme }) => theme.spacing[6]};
  gap: ${({ theme }) => theme.spacing[2]};
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.border.button.marketing.default};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.border.button.marketing.hover};
  }
`;
